import { useQuery } from '@tanstack/react-query';
import API from '../../../../utils/constant';
import type { NationalExam } from '../types';

export function useNationalExams() {
  return useQuery({
    queryKey: ['exam_gen', 'national_exams'],
    queryFn: () =>
      API.get('/api/exam/national/?target_level=school').then((r) => {
        const raw = r.data as any;
        const arr = Array.isArray(raw) ? raw : raw?.results ?? [];
        return arr.map((i: any) => ({ id: i.id, name: i.name })) as NationalExam[];
      }),
  });
}
